function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useGridApiMethod } from "../../utils/useGridApiMethod.js";
import { useGridCellEditing } from "./useGridCellEditing.js";
import { GridCellModes, GridEditModes } from "../../../models/gridEditRowModel.js";
import { useGridRowEditing } from "./useGridRowEditing.js";
import { gridEditRowsStateSelector } from "./gridEditingSelectors.js";
import { isAutogeneratedRowNode } from "../rows/gridRowsUtils.js";
export var editingStateInitializer = function(state) {
    return _extends({}, state, {
        editRows: {}
    });
};
export var useGridEditing = function(apiRef, props) {
    useGridCellEditing(apiRef, props);
    useGridRowEditing(apiRef, props);
    var debounceMap = React.useRef({});
    var isCellEditableProp = props.isCellEditable;
    var isCellEditable = React.useCallback(function(params) {
        if (isAutogeneratedRowNode(params.rowNode)) {
            return false;
        }
        if (!params.colDef.editable) {
            return false;
        }
        if (!params.colDef.renderEditCell) {
            return false;
        }
        if (isCellEditableProp) {
            return isCellEditableProp(params);
        }
        return true;
    }, [
        isCellEditableProp
    ]);
    var maybeDebounce = function(id, field, debounceMs, callback) {
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) {
            debounceMap.current[id] = {};
        }
        if (debounceMap.current[id][field]) {
            var _debounceMap_current_id_field = _sliced_to_array(debounceMap.current[id][field], 1), timeout = _debounceMap_current_id_field[0];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        var runImmediately = function() {
            var _debounceMap_current_id_field = _sliced_to_array(debounceMap.current[id][field], 1), timeout = _debounceMap_current_id_field[0];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        var timeout1 = setTimeout(function() {
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout1,
            runImmediately
        ];
    };
    React.useEffect(function() {
        var debounces = debounceMap.current;
        return function() {
            Object.entries(debounces).forEach(function(param) {
                var _param = _sliced_to_array(param, 2), id = _param[0], fields = _param[1];
                Object.keys(fields).forEach(function(field) {
                    var _debounces_id_field = _sliced_to_array(debounces[id][field], 1), timeout = _debounces_id_field[0];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    var runPendingEditCellValueMutation = React.useCallback(function(id, field) {
        if (!debounceMap.current[id]) {
            return;
        }
        if (!field) {
            Object.keys(debounceMap.current[id]).forEach(function(debouncedField) {
                var _debounceMap_current_id_debouncedField = _sliced_to_array(debounceMap.current[id][debouncedField], 2), runCallback = _debounceMap_current_id_debouncedField[1];
                runCallback();
            });
        } else if (debounceMap.current[id][field]) {
            var _debounceMap_current_id_field = _sliced_to_array(debounceMap.current[id][field], 2), runCallback = _debounceMap_current_id_field[1];
            runCallback();
        }
    }, []);
    var setEditCellValue = React.useCallback(function(params) {
        var id = params.id, field = params.field, debounceMs = params.debounceMs;
        return new Promise(function(resolve) {
            maybeDebounce(id, field, debounceMs, /*#__PURE__*/ _async_to_generator(function() {
                var setEditCellValueToCall, result;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setEditCellValueToCall = props.editMode === GridEditModes.Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                            if (!(apiRef.current.getCellMode(id, field) === GridCellModes.Edit)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                setEditCellValueToCall(params)
                            ];
                        case 1:
                            result = _state.sent();
                            resolve(result);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            }));
        });
    }, [
        apiRef,
        props.editMode
    ]);
    var getRowWithUpdatedValues = React.useCallback(function(id, field) {
        return props.editMode === GridEditModes.Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    var getEditCellMeta = React.useCallback(function(id, field) {
        var _editingState_id;
        var editingState = gridEditRowsStateSelector(apiRef.current.state);
        var _editingState_id_field;
        return (_editingState_id_field = (_editingState_id = editingState[id]) === null || _editingState_id === void 0 ? void 0 : _editingState_id[field]) !== null && _editingState_id_field !== void 0 ? _editingState_id_field : null;
    }, [
        apiRef
    ]);
    var editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    var editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    useGridApiMethod(apiRef, editingSharedApi, 'public');
    useGridApiMethod(apiRef, editingSharedPrivateApi, 'private');
};
